import dayjs from "dayjs";
import * as XLSX from "xlsx";

//for excel download  functionality  to pass the table data as Key And Value Pairs in an array
export const downloadExcel = async (
  tableData,
  name,
  date,
  dateFormat = "MMMM",
  sheetName
) => {
  try {
    if (!tableData.length) return;
    const worksheet = XLSX.utils.json_to_sheet(tableData);
    const colWidths = Object.keys(tableData[0]).map((key) => ({
      wch: Math.max(
        key.length,
        ...tableData.map((row) => (row[key] ? row[key].toString().length : 0))
      ),
    }));
    worksheet["!cols"] = colWidths;
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(
      workbook,
      worksheet,
      `${sheetName} ${dayjs(date).format("MMMM")}`
    );

    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });

    const blob = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `${name}${
      date ? `_${dayjs(date).format(dateFormat)}` : ""
    } .xlsx`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    return true;
  } catch (error) {
    throw error;
  }
};

//mapping our component genbertaed columns and rows with label and values of ourt rows foexcel sheet data generateor
export function mapTableData(rows, columns) {
  return rows.map((row) => {
    const mappedRow = {};
    columns.forEach((col) => {
      mappedRow[col.label] = row[col.key] ?? "-";
    });
    return mappedRow;
  });
}
